// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    allActivities: 'Alle Aktivitätstypen (Aufgabe, Problem, Anfrage)',
    AllActivities_group_title: 'Felder für alle Aktivitätstypen (Aufgabe, Problem, Anfrage)',
    customer: 'Kunde',
    Customer_group_title: 'Kundenfelder',
    default_field_name: 'Neues Feld',
    expense: 'Kosten',
    Expense_group_title: 'Felder für Kosten',
    issue: 'Problem',
    Issue_group_title: 'Problemfelder',
    limitReachedMessage: 'Leider haben Sie die Höchstanzahl an benutzerdefinierten Feldern vom ausgewählten Typ erreicht.',
    msg_deleteUsedValue: 'Dieser Wert wird an {0} {1} verwendet',
    msg_lead_to: 'Diese Änderung bewirkt Folgendes:',
    msg_restrictionsAdded: 'Dieses benutzerdefinierte Feld wird auf bestimmte Portfolios beschränkt sein.',
    msg_restrictionsRemoved: 'Dieses benutzerdefinierte Feld wird nicht mehr auf bestimmte Portfolios beschränkt sein.',
    msg_unportfolioedOff: 'Dieses benutzerdefinierte Feld wird nicht für Projekte verfügbar sein, die nicht zu Portfolios gehören.',
    msg_valueRemoved: 'Ausgeschlossene Listenelemente dieses benutzerdefinierten Feldes werden gelöscht.',
    portfolio: 'Portfolio',
    Portfolio_group_title: 'Portfoliofelder',
    project: 'Projekt',
    Project_group_title: 'Projektfelder',
    request: 'Anfrage',
    Request_group_title: 'Anfragenfelder',
    task: 'Aufgabe',
    Task_group_title: 'Aufgabenfelder',
    text_add: 'Hinzufügen',
    text_add_new_item: 'Fügen Sie ein neues Element hinzu oder fügen Sie mit Strg+V eine Liste mit Elementen ein.',
    text_add_portfolio: 'Portfolio hinzufügen',
    text_addDescription: 'Beschreibung hinzufügen',
    text_all_objects: 'Alle Objekte',
    text_available_in: 'Portfolios für das Feld:',
    text_create_new_field: 'Neues Feld erstellen',
    text_currentIdentity: 'Setzwert',
    text_custom_field_for: 'Feld für',
    text_delete: 'Feld löschen',
    text_delete_permanently: 'Endgültig löschen',
    text_deleteValue: 'Wert löschen',
    text_edit: 'Feldname ändern',
    text_empty_page_part1: 'Benötigen Sie mehr Flexibilität bei der Nachverfolgung und Berichterstellung für Ihre Daten?',
    text_empty_page_part2: 'Fügen Sie Ihre eigenen Felder für Projekte, Aufgaben, Benutzer und mehr hinzu...',
    text_error_title: 'Der Vorgang konnte nicht abgeschlossen werden.',
    text_fieldName: 'Feldname',
    text_fieldType: 'Feldtyp:',
    text_filter: 'Benutzerdefinierte Felder für',
    text_include_in_unportfolioed_projects: 'In nicht in einem Portfolio befindlichen einbeziehen',
    text_isIdentity: 'Autoinkrement',
    text_isNumeric: 'Dezimale nicht anzeigen',
    text_isRequired: 'Obligatorisch',
    text_place_plural: '1#Stelle#Stellen',
    text_remainingValuesTemplate: '{0} ausgeblendete Elemente oben in der Liste anzeigen',
    text_remove: 'Löschen',
    text_restricted_by_portfolio: 'Anhand Portfolio einschränken',
    text_set_restrictions: 'Dieses Feld nur für Projekte anzeigen, die zu den ausgewählten Portfolios gehören',
    timeEntry: 'Zeiteintrag',
    TimeEntry_group_title: 'Felder für Zeiteinträge',
    user: 'Benutzer',
    User_group_title: 'Benutzeranfrage',
};
